import { forIn, isEmpty } from 'lodash';
const AI_PROJECT_INFO_BASE_EXCLUDE_FIELDS = ['ctime', 'mtime', '_ctime', '_mtime'];
export const createAiProjectInfoExclude = ({ excludeArtifact = false } = {}) => [
    ...(excludeArtifact ? ['artifact'] : []),
    ...AI_PROJECT_INFO_BASE_EXCLUDE_FIELDS,
].join(',');
export const getAiArtifactCosEnabled = () => !!window.GLOBAL_INFO?.configuredAiProjectUploader;
/** crossorigin === false 时不注入 preload（HTML 与下方动态 link 一致），否则使用 anonymous */
const shouldInjectAiArtifactPreload = () => window.GLOBAL_INFO?.aiProjectArtifactConfig?.crossorigin !== false;
// 是否启用 slim 模式（仅请求 artifactCos 元信息，artifact 由 COS 还原）。
// 配置了 aiProjectUploader 即开启，dev/branch 也走 slim：服务端已统一在 dev/branch 上传 artifactCos。
// 入参 env/branchId 仅为兼容历史调用方保留，新逻辑不再依赖。
export const shouldUseSlimAiProjectInfo = (_options = {}) => getAiArtifactCosEnabled();
// JS 是进入 COS 路径的最小必要条件，CSS 允许为空字符串或缺省。
export const hasCompleteArtifactCos = (aiProjectInfo) => !!aiProjectInfo?.artifactCos?.js;
const hasExistingPreload = (href, as) => Array
    .from(document.head.querySelectorAll(`link[rel="preload"][as="${as}"]`))
    .some((node) => {
    const link = node;
    return link.href === href || link.getAttribute('href') === href;
});
const appendPreload = (href, as) => {
    if (typeof document === 'undefined' || !href || hasExistingPreload(href, as))
        return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = as;
    link.href = href;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
};
export const preloadArtifactCosAssets = (artifactCos) => {
    if (!artifactCos || !shouldInjectAiArtifactPreload())
        return;
    if (artifactCos.css)
        appendPreload(artifactCos.css, 'fetch');
    if (artifactCos.js)
        appendPreload(artifactCos.js, 'fetch');
    if (!isEmpty(artifactCos.assetFiles)) {
        forIn(artifactCos.assetFiles, (asset) => {
            if (asset.url)
                appendPreload(asset.url, 'fetch');
        });
    }
};
const fetchAssetText = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`Failed to fetch AI artifact asset: ${url}`);
    }
    return await response.text();
};
export const resolveArtifactCosToArtifact = async (artifactCos) => {
    if (!artifactCos?.js) {
        throw new Error('artifactCos.js is required');
    }
    preloadArtifactCosAssets(artifactCos);
    const [js, css] = await Promise.all([
        fetchAssetText(artifactCos.js),
        artifactCos.css ? fetchAssetText(artifactCos.css) : Promise.resolve(artifactCos?.css ?? ''),
    ]);
    return {
        ...artifactCos,
        js,
        css,
    };
};
